import { defineMessages } from 'react-intl';

export default defineMessages({
  empty: 'No accounts',
  create: 'Create account',
  personalDataController: 'PDC',
  personalDataControllerTooltip: 'Personal Data Controller',
  allowPersonalData: 'Allow Personal Data',
  allowPersonalDataTooltip: 'Allow Personal Data to be shown in results, disables personal data filter.',
  logo: 'Logo',
});
